// JsFromRoutes CacheKey a4c7d805e40119b241c2a115e96943c6
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/nps/:token'),
  update: /* #__PURE__ */ definePathHelper('patch', '/nps/:token'),
  recordClick: /* #__PURE__ */ definePathHelper('post', '/nps/:token/click'),
}
